<style lang="scss">
  @import '../resources/scss/footer.scss';
</style>

<script lang="ts">
  import type FooterSection from '../api/rest/directus-cms/app/models/FooterSection'
  import { onDestroy } from 'svelte'
  import logoDecoded from '../resources/assets/logo_footer.svg'
  import { commonWebsiteData } from '../stores/stores'

  let footerSectionData: FooterSection

  const unsubscribeWebsiteData = commonWebsiteData.subscribe(data => {
    if (data?.footer_section) footerSectionData = data.footer_section
  })

  onDestroy(() => {
    unsubscribeWebsiteData()
  })
</script>

{#if footerSectionData}
  <footer class="footer container-fluid">
    <div class="container-xxl">
      <div class="row justify-content-center pb-3">
        <div class="col-12">
          <div class="row align-items-top justify-content-center">
            <div class="logo col-md-6 col-lg-3">
              {@html logoDecoded}
            </div>
            <div class="col-md-6 col-lg-9 text-center footer-links">
              <div class="row justify-content-end gy-3">
                {#each footerSectionData.menuItems as menuItem}
                  <div class="col-md-auto">
                    <a class="footer-text caption1" href={menuItem.link}
                      >{menuItem.name}</a
                    >
                  </div>
                {/each}
                <div class="col-md-auto text-center text-md-start">
                  <span id="contacts" class="footer-text ps-md-3 caption1"
                    >{footerSectionData.contacts}</span
                  >
                  {#if footerSectionData.address}
                    <span class="footer-text d-block body-2 ps-md-3"
                      >{footerSectionData.address}</span
                    >
                  {/if}
                  {#if footerSectionData.postalCode}
                    <span class="footer-text d-block body-2 ps-md-3"
                      >{footerSectionData.postalCode}</span
                    >
                  {/if}
                  <span class="footer-text body-2 ps-md-3">{footerSectionData.email}</span
                  >
                </div>
              </div>
            </div>
            <div class="col-12 text-start">
              <div class="all-rights my-3" />
            </div>
            <div class="col-12 text-center text-md-start lh-1">
              <span class="footer-text body-2"
                >{footerSectionData.copyrightText} © {new Date().getFullYear()}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
{/if}
